import {Button, Card, Col, Divider, Form, Input, message, Modal, Row, Space} from "antd";
import customerChangeRequestService from "../../../service/customerChangeRequestService";
import ErrorHandler from "../../../util/ErrorHandler";
import {useEffect, useState} from "react";
import {MSG_CONTACT_DETAIL_CHANGE_HISTORY_LIST_FETCH_FAILURE_ERROR} from "../../../util/Messages";
import {OtherRequestDto} from "../../../dto/OtherRequestDto";
import {ContactDetailDto} from "../../../dto/ContactDetailDto";
import ChangeRequestHistoryTableComp from "./changeRequestHistoryTableComp";
import TextArea from "antd/es/input/TextArea";
import modal from "antd/es/modal";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {CHANGE_REQUEST_RECORD_STATUS} from "../../../util/Constants";


interface ContactDetailsChangeHistoryProp {
    cin: string
    handleTabChange: (activeKey: string) => void
}

const ContactDetailsChangeHistoryComp = (props: ContactDetailsChangeHistoryProp) => {
    const [form] = Form.useForm();
    const [isLoading, setLoading] = useState(false);
    const [contactDetailChangeHistoryList, setContactDetailChangeHistoryList] = useState<OtherRequestDto[]>()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCanShowRejectReason, setCanShowRejectReason] = useState(false);
    const [selectedCin, setSelectedCin] = useState("");
    const [isShowCancelRequest, setShowCancelRequest] = useState<boolean>(false)

    useEffect(() => {
        fetchContactDetailChangeHistory(props.cin)
    }, []);


    const fetchContactDetailChangeHistory = (cin: string) => {
        setLoading(true)
        customerChangeRequestService.getContactDetailChangeRequestHistory(cin).then((res) => {
            if (res.data.results) {
                setContactDetailChangeHistoryList(res.data.results)
                setLoading(false)
            } else {
                message.error(MSG_CONTACT_DETAIL_CHANGE_HISTORY_LIST_FETCH_FAILURE_ERROR)
                setLoading(false)
            }
        }).catch(reason => {
            ErrorHandler.handleError(reason)
            setLoading(false)
        })
    }

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onCancelRequest = () => {
        setLoading(true)
        modal.confirm({
            title: 'Confirm',
            className: 'confirm-dialog-box',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to cancel this contact detail change request?`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                customerChangeRequestService.cancelCustomerContactChangeRequest(selectedCin).then(res => {
                    if (res.data !== null && res.data.results) {
                        message.success("Contact detail change request cancelled successfully").then();
                        handleCancel()
                        setLoading(false)
                        props.handleTabChange("1")
                    } else {
                        message.error("Contact detail change request cancel failure").then();
                        setLoading(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setLoading(false)
                })
            },
            onCancel() {
                setLoading(false)
            }
        });
    }

    const showModal = (record: ContactDetailDto) => {
        setFormValues(record)
        setShowCancelRequest(CHANGE_REQUEST_RECORD_STATUS.SUBMITTED === record.recordStatus)
        setSelectedCin(record.cin)
        setIsModalOpen(true);

    };

    const setFormValues = (data: ContactDetailDto | undefined) => {
        if (undefined != data) {
            form.setFieldsValue({
                email: data.email,
                homePhoneNumber: data.homePhoneNumber,
                officePhoneNumber: data.officePhoneNumber,
                faxNumber: data.faxNumber,
                mobileNumber: data.mobileNumber,
                rejectReason: data.rejectReason,
            })
            setCanShowRejectReason(null != data.rejectReason)
        }
    }

    return (
        <>
            <Row gutter={[24, 12]}>

                <Col span={24}>
                    <ChangeRequestHistoryTableComp tableData={contactDetailChangeHistoryList} onShowModal={showModal}
                                                   loading={isLoading}/>
                </Col>
            </Row>
            <Modal title="Contact Details Update History"
                   open={isModalOpen}
                   footer={null}
                   onCancel={handleCancel}
                   width={800}
                   centered
                   style={{top: 20, paddingBottom: 20}}
                   destroyOnClose={true}
                   maskClosable={false}>
                <Row gutter={[24, 12]} className={'form-item-mb-12'} style={{marginTop: 18}}>
                    <Col span={24}>
                        <Card title="Contact Details" size={'small'}>
                            <Form
                                className='form-input'
                                layout={"vertical"}
                                form={form}
                            >
                                <Row gutter={[12, 0]}>
                                    <Col xxl={8} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Mobile Number"
                                            name={"mobileNumber"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={8} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Fax Number"
                                            name={"faxNumber"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={8} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Office Phone Number"
                                            name={"officePhoneNumber"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={8} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Residential Phone Number"
                                            name={"homePhoneNumber"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Form.Item
                                            label="Email"
                                            name={"email"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>
                                    {isCanShowRejectReason ?
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Divider></Divider>
                                            <Form.Item
                                                name={"rejectReason"}
                                                label={"Reject Reason"}>
                                                <TextArea disabled bordered={true}/>
                                            </Form.Item>
                                        </Col>
                                        :
                                        <></>
                                    }

                                </Row>
                            </Form>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Divider style={{marginBottom: 12}}></Divider>
                    </Col>
                    <Col span={24}>
                        <Space style={{float: 'right'}}>
                            {isShowCancelRequest ?
                                <Button
                                    onClick={onCancelRequest}>Cancel Request</Button> :
                                <Button
                                    onClick={handleCancel}
                                    style={{width: 80}}>Cancel</Button>}
                        </Space>
                    </Col>
                </Row>

            </Modal>

        </>
    )
}
export default ContactDetailsChangeHistoryComp;